<span [ngClass]="{'dot-active': isActive, 'dot-inactive': !isActive}">
  {{ mappedStatus }}
</span>
